export enum PolicyType {
  BLI = 'bli',
  MDT = 'mdt',
  CMV = 'cmv',
  CWP = 'cwp',
}
